import { Grid } from '@mui/material';

// Common Props
import CommonPropTypes from 'shared/prop-types';

function FormContainer({ children, sx }) {
	return (
		<Grid
			component="form"
			container
			item
			noValidate
			columnSpacing={2}
			rowSpacing={3}
			autoComplete="off"
			sx={{
				marginBottom: 4,
				...sx
			}}
		>
			{children}
		</Grid>
	);
}

FormContainer.propTypes = {
	sx: CommonPropTypes.sx
};

FormContainer.defaultProps = {
	sx: {}
};

export default FormContainer;
